var React = require('react');

function ExpoSecBlkRgb (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M24.375,15c5.169,0,9.375,4.206,9.375,9.375s-4.206,9.375-9.375,9.375S15,29.545,15,24.375S19.206,15,24.375,15 M24.375,0\n\t\tC10.913,0,0,10.913,0,24.375S10.913,48.75,24.375,48.75c13.462,0,24.375-10.913,24.375-24.375S37.837,0,24.375,0L24.375,0z"})));
}

ExpoSecBlkRgb.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 48.75 48.75","style":{"enableBackground":"new 0 0 48.75 48.75"},"xmlSpace":"preserve"};

module.exports = ExpoSecBlkRgb;

ExpoSecBlkRgb.default = ExpoSecBlkRgb;
